Vue.mixin({
    methods: {
        // global function for getting assets
        getAsset: function (file) {
            return this.$root.$DForce.assetUrl(file);
        }
    }
});


// WEBPACK FOOTER //
// ./src/utils/assets.js